import React from 'react'
import HomePage from '../components/HomePage/HomePage'
import Bakterie from '../components/Bakterie/Bakterie'
import WilkiOwcaPage from '../components/WilkOwca/WilkOwca'
import NavBar from '../components/NavBar/NavBar'
import Granice from '../components/Granice/Granice'
import Zombie from "../components/Zombie/Zombie";
import { Routes, Route} from 'react-router';

const Home = () => {
    return (
        <>
            <NavBar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/bakterie" element={<Bakterie />} />
                <Route path="/wilk-owca" element={<WilkiOwcaPage />} />
                <Route path="/granice" element={<Granice />} />
                <Route path="/zombie" element={<Zombie />} />
            </Routes>
        </>
    )
}

export default Home
